import Avatar from '@mui/material/Avatar';
import TipoRemessaJulgamentoProcesso, {
    TIPO_REMESSA_JULGAMENTO_PROCESSO
} from '@/dominio/TipoRemessaJulgamentoProcesso';
import { makeObservable, observable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroTipoRemessaJulgamento extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';
    selecaoMultipla = true;

    get label() {
        return 'Tipo de remessa de julgamento';
    }

    getIconeFiltroRapido(cor) {
        return (
            <Avatar
                sx={{
                    width: '26px',
                    height: '26px',
                    fontWeight: '600',
                    fontSize: '0.98rem',
                    backgroundColor: cor
                }}
                variant="square"
            >
                R
            </Avatar>
        );
    }

    opcoesFiltro = FiltroTipoRemessaJulgamento.#carregarOpcoes();

    filtroRapido = {
        opcoes: this.getOpcoesFiltro('valor', 'cor')
    };

    static #carregarOpcoes() {
        const opcoes = [];

        for (const tipoRemessa of Object.values(TIPO_REMESSA_JULGAMENTO_PROCESSO)) {
            const opcao = {
                valor: tipoRemessa.codigo,
                cor: tipoRemessa.cor,
                icone: TipoRemessaJulgamentoProcesso.getIcone(tipoRemessa.id)
            };

            opcoes.push(opcao);
        }

        return opcoes;
    }

    constructor(props) {
        super(props);

        makeObservable(this, {
            filtroRapido: observable
        });
    }

    getValorOpcao(registro) {
        if (registro?.remessaJulgamento?.tipo?.id) {
            return registro.remessaJulgamento.tipo.id;
        }

        return TIPO_REMESSA_JULGAMENTO_PROCESSO.NR.codigo;
    }

    getDescricao(valor) {
        if (typeof valor === 'undefined') {
            return '';
        }

        return TipoRemessaJulgamentoProcesso.getDescricao(valor);
    }
}
